module.exports = __webpack_public_path__ + "static/media/logo-large.1a2b2e41.png";